/* tslint:disable */
/* eslint-disable */
export enum MethodImplAttributes {
  Il = 'IL',
  Native = 'Native',
  Optil = 'OPTIL',
  CodeTypeMask = 'CodeTypeMask',
  ManagedMask = 'ManagedMask',
  NoInlining = 'NoInlining',
  ForwardRef = 'ForwardRef',
  Synchronized = 'Synchronized',
  NoOptimization = 'NoOptimization',
  PreserveSig = 'PreserveSig',
  AggressiveInlining = 'AggressiveInlining',
  AggressiveOptimization = 'AggressiveOptimization',
  InternalCall = 'InternalCall',
  MaxMethodImplVal = 'MaxMethodImplVal'
}
